/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Timecode_Format_SmpteInputs */

const en_transcript_export_timecode_format_smpte = /** @type {(inputs: Transcript_Export_Timecode_Format_SmpteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMPTE (hh:mm:ss:ff)`)
};

const fr_transcript_export_timecode_format_smpte = /** @type {(inputs: Transcript_Export_Timecode_Format_SmpteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMPTE (hh:mm:ss:ff)`)
};

const de_transcript_export_timecode_format_smpte = /** @type {(inputs: Transcript_Export_Timecode_Format_SmpteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMPTE (hh:mm:ss:ff)`)
};

const it_transcript_export_timecode_format_smpte = /** @type {(inputs: Transcript_Export_Timecode_Format_SmpteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMPTE (hh:mm:ss:ff)`)
};

const ru_transcript_export_timecode_format_smpte = /** @type {(inputs: Transcript_Export_Timecode_Format_SmpteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMPTE (чч:мм:сс:фф)`)
};

const es_transcript_export_timecode_format_smpte = /** @type {(inputs: Transcript_Export_Timecode_Format_SmpteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMPTE (hh:mm:ss:ff)`)
};

const zh_cn2_transcript_export_timecode_format_smpte = /** @type {(inputs: Transcript_Export_Timecode_Format_SmpteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMPTE（hh:mm:ss:ff）`)
};

const ja_transcript_export_timecode_format_smpte = /** @type {(inputs: Transcript_Export_Timecode_Format_SmpteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMPTE (時:分:秒:早送り)`)
};

const hi_transcript_export_timecode_format_smpte = /** @type {(inputs: Transcript_Export_Timecode_Format_SmpteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एसएमपीटीई (hh:mm:ss:ff)`)
};

const pt_pt2_transcript_export_timecode_format_smpte = /** @type {(inputs: Transcript_Export_Timecode_Format_SmpteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMPTE (hh:mm:ss:ff)`)
};

/**
* | output |
* | --- |
* | "SMPTE (hh:mm:ss:ff)" |
*
* @param {Transcript_Export_Timecode_Format_SmpteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_timecode_format_smpte = /** @type {((inputs?: Transcript_Export_Timecode_Format_SmpteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Timecode_Format_SmpteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_timecode_format_smpte(inputs)
	if (locale === "de") return de_transcript_export_timecode_format_smpte(inputs)
	if (locale === "it") return it_transcript_export_timecode_format_smpte(inputs)
	if (locale === "ru") return ru_transcript_export_timecode_format_smpte(inputs)
	if (locale === "es") return es_transcript_export_timecode_format_smpte(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_timecode_format_smpte(inputs)
	if (locale === "ja") return ja_transcript_export_timecode_format_smpte(inputs)
	if (locale === "hi") return hi_transcript_export_timecode_format_smpte(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_timecode_format_smpte(inputs)
	return en_transcript_export_timecode_format_smpte(inputs)
});